import type { MouseEventHandler, ReactElement, UIEvent } from "react";

import { handleClickForKeyboard } from "simplydo/core/accessibility";
import { styled } from "simplydo/react/styled";

import { RenderCard } from "./Card";
import type { CardProps } from "./Card.types";

export type CardButtonProps = Omit<CardProps, "onClick"> & {
  onClick: MouseEventHandler<HTMLElement>;
  "aria-label"?: string;
  "aria-pressed"?: boolean;
};

/** A card that is one button. Only for cards with nothing interactive inside. */
const CardButtonComponent = ({
  onClick,
  ...props
}: CardButtonProps): ReactElement => (
  <RenderCard
    {...props}
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={handleClickForKeyboard(onClick as (e: UIEvent) => void)}
  />
);

export const CardButton = styled(CardButtonComponent)``;
